/** Logo 5: tamnoplava grafika za svetlu pozadinu. */
export const LOGO_FOR_LIGHT_BACKGROUND = '/assets/logo/logo-light/logo-light.png';

/** Logo 4: svetla grafika za tamnu pozadinu. */
export const LOGO_FOR_DARK_BACKGROUND = '/assets/logo/logo-dark/logo-dark.png';

/** Jedan URL za semantiku / mejl (sveta pozadina). */
export const LOGO_PRIMARY_URL = LOGO_FOR_LIGHT_BACKGROUND;
